import { useState } from 'react'
import { toast } from 'react-toastify'

const useFetch = (initialState = false) => {
    const [isLoading, setLoader] = useState(initialState)
    const [ status,setStatus ]  = useState<string>()
    const [ error,setError ]  = useState<string>()


    const clearError = () => {
        if(error)
        setError('')
    }

    const load = async <T>(aPromise:Promise<T | any>) => {
        setLoader(true)
        clearError()
        return aPromise
        .catch(er => {
            setStatus(er.status);
            if (er.error) {
                toast.error(er.error);
                setError(er.error);
                throw new Error(er.error)
            } else {
                toast.error(er.message);
                setError(er.message);
                throw new Error(er.message)
            }
        })
        .finally(() => setLoader(false))
    }


    return { isLoading,load, error, status, setLoader, clearError, setError } as const
}

export default useFetch

